import { useState, useEffect } from "react";
import GameForm from "../components/GameForm";
import React from "react";
import { pickId } from "../utils";

const AdminCreatePage: React.FC = () => {
  const [gameId, setGameId] = useState<string | null>(null);

  const handleGameCreation = () => {
    console.log("Redirecting to AdminGamePage");
    window.location.pathname = `/admin/game/${gameId}`;
  };

  useEffect(() => {
    const id = pickId();
    setGameId(id);
  }, []);

  if (!gameId) {
    return <div>Loading...</div>;
  }

  return <GameForm gameId={gameId} handleGameCreation={handleGameCreation} />;
};

export default AdminCreatePage;
